import { render, staticRenderFns } from "./EbookTestimonial.vue?vue&type=template&id=f5a831a0"
import script from "./EbookTestimonial.vue?vue&type=script&lang=js"
export * from "./EbookTestimonial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports